/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Etbis_AriaInputs */

const tr_legal_footer_etbis_aria = /** @type {(inputs: Legal_Footer_Etbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS Kayıtlı - Kayıt No 4735819565 (Resmi Doğrulama Linki)`)
};

const en_legal_footer_etbis_aria = /** @type {(inputs: Legal_Footer_Etbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered with ETBİS, registration number 4735819565 (official verification link)`)
};

const de_legal_footer_etbis_aria = /** @type {(inputs: Legal_Footer_Etbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei ETBİS registriert, Registrierungsnummer 4735819565 (offizieller Verifizierungslink)`)
};

const ru_legal_footer_etbis_aria = /** @type {(inputs: Legal_Footer_Etbis_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрировано в ETBİS, регистрационный номер 4735819565 (официальная ссылка для проверки)`)
};

/**
* | output |
* | --- |
* | "Registered with ETBİS, registration number 4735819565 (official verification link)" |
*
* @param {Legal_Footer_Etbis_AriaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_etbis_aria = /** @type {((inputs?: Legal_Footer_Etbis_AriaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Etbis_AriaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_etbis_aria(inputs)
	if (locale === "de") return de_legal_footer_etbis_aria(inputs)
	if (locale === "ru") return ru_legal_footer_etbis_aria(inputs)
	return tr_legal_footer_etbis_aria(inputs)
});